<div class="sidebar theme-alternate" [class.collapsed]="collapsed">
	<div class="toggle-bar">
		<div class="active-indicator padded">
			<bb-button (click)="onToggleClick()" [naked]="true" [active]="!collapsed" theme="dark">
				<i class="fas fa-cog"></i>
			</bb-button>
		</div>
		<div class="refresh-container padded">
			<bb-button (click)="onRefreshClick()" [naked]="true" theme="dark">
				<i class="fas fa-refresh"></i>
			</bb-button>
		</div>
	</div>
	<div class="preview-settings">
		<div class="info">
			<h2>
				{{ 'PREVIEW_SETTINGS' | translate }}
			</h2>
			<bb-button class="close" (click)="onCloseClick()" [naked]="true" theme="dark">
				<i class="fas fa-times"></i>
			</bb-button>
		</div>
		<div *ngIf="timeline?.updateddate" class="updated-time">
			<!-- Interactivity -->
			Last update <strong>{{ timeline?.updateddate | bbDate:'relative' }}</strong>
		</div>
		<div class="preview-parts">
			<div class="cat" [hasPermission]="'root'">
				<a [href]="iframeSrc" target="_blank" class="open-in-new-tab">
					<i class="fas fa-external-link-alt"></i>
					<span> {{ 'OPEN_IN_NEW_TAB' | translate }}</span>
				</a>
			</div>
			<!-- Leaving some HTML comments in here that we might use later. -->
			<div class="cat">
				<ng-container *ngIf="routeParams.type === 'p' && project">
					<h5>
						<i class="fa fa-paper-plane"></i>
						<span>{{ project.title || project.name }}</span>
					</h5>
				</ng-container>
				<ng-container *ngIf="routeParams.templateId && template">
					<h5>
						<i class="fa fa-cube"></i>
						<span>{{ template.name }}</span>
					</h5>
				</ng-container>
				<ng-container *ngIf="routeParams.type === 'c' && mediaclip">
					<h5>
						<span [innerHTML]="mediaclip | clipIcon"></span>
						<span [innerHTML]="mediaclip | clipTitle"></span>
					</h5>
				</ng-container>
			</div>
			<div class="cat">
				<mat-form-field appearance="fill">
					<mat-label>{{ 'PLAYOUT' | translate }}</mat-label>
					<bb-entity-selector theme="dark" [inMatFormField]="true" [disableClear]="true"
						[hideThumbnail]="true" [hideIcons]="true" [entityType]="'playout'"
						[(ngModel)]="routeParams.playout" name="playout"
						(ngModelChange)="onPlayoutChange()"
						[filterSet]="[{
							filters: [{
								type: 'playout',
								field: 'status',
								operator: 'isNot',
								value: 'inactive'
							}]
						}]"
					></bb-entity-selector>
				</mat-form-field>
			</div>
			<!-- <div class="cat">
				<bb-floating-label [label]="'PREVIEW_TYPE' | translate" theme="dark">
					<bb-select
						theme="dark"
						class="ie-form-field-styling"
						[(ngModel)]="routeParams.type"
						[options]="typeOptions"
						[placeholder]="'Select a type'"
						(ngModelChange)="onTypeChange()"
					></bb-select>
				</bb-floating-label>
			</div> -->
			<!-- <div class="cat" [class.active]="routeParams.type === 'p'" *ngIf="routeParams.type === 'p'">
				<bb-floating-label [label]="'PROJECT' | translate">
					<bb-entity-selector theme="dark" [class.disabled]="routeParams.type !== 'p'"
						[entityType]="'project'" [disableClear]="true" [(ngModel)]="routeParams.projectId"
						name="projectId" (ngModelChange)="onProjectChange()"></bb-entity-selector>
				</bb-floating-label>
			</div> -->
			<!-- <div class="cat">
				<bb-floating-label [label]="'PROJECT_CONTEXT' | translate" theme="dark"
					*ngIf="project && projectContextOptions?.length">
					<bb-select theme="dark" class="ie-form-field-styling" [(ngModel)]="routeParams.projectContext"
						(ngModelChange)="onContextChange()" [options]="projectContextOptions"
						[placeholder]="'Select a context'"></bb-select>
				</bb-floating-label>
			</div> -->
			<div class="cat" *ngIf="projectContextOptions?.length">
				<mat-form-field appearance="fill">
					<mat-label>{{ 'PROJECT_CONTEXT' | translate }}</mat-label>
					<bb-entity-selector
						theme="dark"
						name="context"
						[inMatFormField]="true"
						[placeholder]="'Select a context'"
						[options]="projectContextOptions"
						[(ngModel)]="routeParams.projectContext"
						(ngModelChange)="onContextChange()"
					></bb-entity-selector>
				</mat-form-field>
			</div>
			<!-- <div class="cat" [class.active]="routeParams.type === 'c'">
				<bb-floating-label [label]="'MEDIACLIP' | translate">
					<bb-entity-selector
						[class.disabled]="routeParams.type !== 'c'"
						theme="dark"
						[hideThumbnail]="true"
						[hideIcons]="true"
						[entityType]="'mediaclip'"
						[disableClear]="true"
						[(ngModel)]="routeParams.clipId" name="mediaclipId" (ngModelChange)="onClipChange()"
					></bb-entity-selector>
				</bb-floating-label>
				<small *ngIf="mediaclip?.updateddate">
					Last updated: {{ mediaclip?.updateddate | bbDate:'date-day-time':'long' }}
				</small>
			</div> -->
		</div>
	</div>
</div>
<div class="iframe-container">
	<iframe *ngIf="locationService.server && iframeSrc" [src]="iframeSrc" frameborder="0"></iframe>
</div>
<div class="loading-container"
	[style.opacity]="!routeParams.templateId && !routeParams.projectId && routeParams?.clipId !== mediaclip?.id ? '1' : '0'">
	<bb-loading></bb-loading>
</div>
